import * as ToggleGroup from "@radix-ui/react-toggle-group"
import { fontVariants, styled, theme } from "../../styles/stitches.config"

export const StyledRoot = styled(ToggleGroup.Root, {
  backgroundColor: theme.colors.white,
  boxShadow: theme.shadows.default,
  display: "inline-flex",
  justifyContent: "row",
})

export const StyledItem = styled(ToggleGroup.Item, {
  border: "none",
  margin: 0,
  height: "30px",
  paddingLeft: theme.sizes.s3,
  paddingRight: theme.sizes.s3,
  cursor: "pointer",
  backgroundColor: theme.colors.transparent,
  variants: {
    active: {
      true: {
        ...fontVariants.headerH5,
        backgroundColor: theme.colors.secondary,
      },
      false: {
        ...fontVariants.labelsAlt,
      },
    },
  },
})
